if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      this.querySelector('.quick-add-modal__overlay')?.addEventListener('click', () => this.hide());
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      if (preventFocus) this.openedBy = null;
      this.dispatchEvent(new CustomEvent('quickview:closed'));
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
      let quickviewURL = opener.getAttribute('data-product-url')
      if (!quickviewURL.includes('?view=') && !quickviewURL.includes('&view=')) {
        if (quickviewURL.includes('?')) {
          quickviewURL += "&view=quickview"
        } else {
          quickviewURL += "?view=quickview"
        }
      }
      fetch(quickviewURL)
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="quickview-"]');
          this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
          if(this.productElement) {
            this.productId = this.productElement.dataset.productId;
          }
          this.setInnerHTML(this.modalContent, this.productElement);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();
          //this.setGallery();
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner')?.classList.add('hidden');

          this.dispatchEvent(new CustomEvent('quickview:loaded', { detail: {
            productId: this.productId
          }}));
        });
    }

    setInnerHTML(element, html) {
      const oldMainContent = element.querySelector('.td-product-quickview__main');
      const newMainContent = html.querySelector('.td-product-quickview__main');
      if(newMainContent) {     
        oldMainContent.innerHTML = newMainContent.innerHTML;
      }
      const oldMediaContent = element.querySelector('.td-product-quickview__media');
      const newMediaContent = html.querySelector('.td-product-quickview__media');
      if(newMediaContent) {
        const mediaGallery = oldMediaContent.querySelector('[data-product-images-slider]');
        const imagesWrapper = mediaGallery.querySelector('[data-product-images]');
        const thumbsWrapper = mediaGallery.querySelector('.swiper-thumbs .swiper-wrapper');
        const newImages = Array.from(newMediaContent.querySelectorAll("[data-product-images] [data-product-image]"));
        imagesWrapper.querySelectorAll('[data-product-image]').forEach(e => e.remove());
        if(thumbsWrapper) {
          thumbsWrapper.querySelectorAll('[data-swiper-slide]').forEach(e => e.remove());
          const newThumbs = Array.from(newMediaContent.querySelectorAll(".swiper-thumbs [data-swiper-slide]"));
          newThumbs.forEach((thumb) => thumbsWrapper.innerHTML += thumb.outerHTML);
        }
        mediaGallery.dispatchEvent(new CustomEvent('update-slides', {detail: {slides: newImages, index: 0}}));
      }
    }
  });
}
